<!-- pagerWrap -->
<div class="pagination row"
    [ngClass]="isMobile ? 'mobile-pagination' : (!turnOnLenOptions && !turnOnTotalItem) ? 'desktop-pagination justify-content-center' : 'desktop-pagination' ">
    <ng-container *ngIf="turnOnLenOptions">
        <div class="col-auto per-page row">
            <div class="label col-auto"><span>페이지표시</span></div>
            <select-dropdown class="dropdown-select col row" [options]="options" [selected]="selectedValue"
                (changeSelectedValue)="onChangeLen($event);"></select-dropdown>
        </div>
    </ng-container>

    <ng-container *ngIf="turnOnPagination">
        <div class="col-auto row paging"
            [ngStyle]="{'flex-grow' : (turnOnLenOptions && turnOnPagination && !turnOnTotalItem) || (!turnOnLenOptions && turnOnPagination && turnOnTotalItem) ? '1' : '0'}">
            <pagination-template #p="paginationApi" class="pagerWrap col-auto row paging" [id]="config.id + ''"
                [maxSize]="maxSize" (pageChange)="onChangePage($event);" *ngIf="totalPages > 1">
                <a *ngIf="totalPages > 5" [class.disabled]="p.isFirstPage()" (click)="onChangePage(1);">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M11 17l-5-5 5-5M18 17l-5-5 5-5" />
                    </svg>
                </a>

                <a [class.disabled]="p.isFirstPage()" (click)="onChangePage(page - 1);">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M15 18l-6-6 6-6" />
                    </svg>
                </a>

                <ng-container *ngFor="let page of p.pages; index as i;">
                    <!-- case 1: totalPages <= 5 then load all -->
                    <ng-container *ngIf="totalPages <= displaySize">
                        <a (click)="p.setCurrent(page.value);" [class.on]="p.getCurrent() === page.value"
                            [ngClass]="p.getCurrent() === page.value ? 'active disabled' : ''">
                            {{ page.value }}
                        </a>
                    </ng-container>

                    <!-- case 2: when totalPages > 5 -->
                    <ng-container *ngIf="totalPages > displaySize">
                        <!-- case 2.a: when currentPage <= 3(center) then remove last 2 pages -->
                        <ng-container *ngIf="p.getCurrent() <= centerIndex && i < displaySize">
                            <a (click)="p.setCurrent(page.value);" [class.on]="p.getCurrent() === page.value"
                                [ngClass]="p.getCurrent() === page.value ? 'active disabled' : ''">
                                {{ page.value }}
                            </a>
                        </ng-container>

                        <!-- case 2.b: when currentPage > 3(center) and currentPage < totalPages - 1 then remove first page and last page -->
                        <ng-container
                            *ngIf="p.getCurrent() > centerIndex && i > 0 && i < maxSize - 1 && p.getCurrent() < totalPages - 2 ">
                            <a (click)="p.setCurrent(page.value);" [class.on]="p.getCurrent() === page.value"
                                [ngClass]="p.getCurrent() === page.value ? 'active disabled' : ''">
                                {{ page.value }}
                            </a>
                        </ng-container>

                        <!-- case 2.c: when last 5 pages but totalPages < 7 then remove first page -->
                        <ng-container *ngIf="totalPages < maxSize && p.getCurrent() >= totalPages - 2 && i > 0">
                            <a (click)="p.setCurrent(page.value);" [class.on]="p.getCurrent() === page.value"
                                [ngClass]="p.getCurrent() === page.value ? 'active disabled' : ''">
                                {{ page.value }}
                            </a>
                        </ng-container>

                        <!-- case 2.d: when last 5 pages but totalPages >= 7 then remove first 2 pages -->
                        <ng-container *ngIf="totalPages >= maxSize && p.getCurrent() >= totalPages - 2 && i > 1">
                            <a (click)="p.setCurrent(page.value);" [class.on]="p.getCurrent() === page.value"
                                [ngClass]="p.getCurrent() === page.value ? 'active disabled' : ''">
                                <span>{{ page.value }}</span>
                            </a>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <a [class.disabled]="p.isLastPage()" (click)="onChangePage(page + 1);">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 18l6-6-6-6" />
                    </svg>
                </a>
                <a *ngIf="totalPages > 5" class="col-auto nav-btn" [class.disabled]="p.isLastPage()"
                    (click)="onChangePage(totalPages);">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M13 17l5-5-5-5M6 17l5-5-5-5" />
                    </svg>
                </a>

            </pagination-template>
        </div>

    </ng-container>

    <ng-container *ngIf="turnOnTotalItem">
        <div class="col-auto total">
            <span class="label">Total</span>
            <span class="value">{{ totalItems }}</span>
        </div>
    </ng-container>
</div>
